module.exports = __webpack_public_path__ + "static/photo_3-42f218750a5093aeafb4c5f8ca62447e.jpg";